import Vue from 'vue'
import Toasted from 'vue-toasted'
import 'material-icons'

Vue.use(Toasted)

const duration = 6000

Vue.toasted.register('error', (error = null) => {
  if (error) {
    if (error.response && error.response.data) {
      if (error.response.data.error) return error.response.data.error.join(', ')
      if (error.response.data.message) return error.response.data.message
    }
    if (error.message) return error.message
  }
  return 'Oops.. Algo salio mal, intenta mas tarde'
},
{ type: 'error', icon: 'error_outline', duration })

Vue.toasted.register('warning', (payload = { message: 'Advertencia' }) => payload.message,
  { type: 'warning', icon: 'error_outline', duration })

Vue.toasted.register('success', (payload = { message: 'Èxito' }) => payload.message,
  { type: 'success', icon: 'check_circle_outline', duration })

Vue.toasted.register('info', (payload = { message: 'Informativo' }) => payload.message,
  { type: 'info', icon: 'help_outline', duration })
